export const PartnerRequestStatus = {
    REQUESTED : "REQUESTED",
    REJECTED : "REJECTED",
    CONFIRMED : "CONFIRMED",
    REMOVED : "REMOVED",
}
